import React from 'react'
import toast from 'react-hot-toast'

const ToastMessage = (message) => {
    const notify = () => toast.success(message);

    return (
        <>
           {notify()}
        </>
    )
}

export default ToastMessage;